import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `TransferControllerStateProvider` not mounted on RN.
export default function useTransferControllerState(): any {
  const { state } = useController('TransferController' as any)
  return { state: state || {} }
}
